<template>
    <div>
        <el-dialog :close-on-click-modal="false" title="导入excel文件" append-to-body v-bind="$attrs"  v-on="$listeners">
            <el-form  label-width="120px">
                <el-form-item label="点击下载模板：">
                    <el-button style="width: 108px" @click="downTemp" size="small" type="primary">模板下载<i class="el-icon-upload el-icon--right"></i></el-button>
                </el-form-item>
                <el-form-item label="文件导入：">
                    <el-upload
                            class="upload-demo"
                            action=""
                            :before-upload="beforeUpload"
                            multiple  >
                        <el-button size="small" type="primary">导入EXCEL<i class="el-icon-upload el-icon--right"></i></el-button>
                    </el-upload>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="callback">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import uploaddown from '../../utils/updownfile'
    import _ from 'loadsh'
    export default {
        props:{
            refid:null,
            reftype:null,
            clsname:null,
            startrow:{
                type: Number,
                default: 0
            },
            extparams:{},
        },
        data(){
          return {
              fileList: [],
              resultdata:null,
              msg:null,
          }
        },
        mounted(){
            uploaddown.listdownfile({refid:this.refId, reftype: this.refType}).then(rd => {
                if(rd.obj && rd.obj.length>0){
                    this.fileList.push(rd.obj[rd.obj.length-1])
                }
            })
        },
        computed: {
            clsName:function(){
                return this.clsname;
            },
            startRow:function () {
                return this.startrow;
            },
            refId:function () {
                return this.refid||this.clsname;
            },
            refType:function () {
                return this.reftype||this.clsname;
            },
            extParams:function () {
                return this.extparams;
            }
        },
        methods: {
            beforeUpload(file){
                uploaddown.importExcel(file, {clsname: this.clsName, startrow: this.startRow,extparams:this.extParams }).then(rd => {
                    this.resultdata = rd;
                    debugger
                    if(rd.f){
                        this.msg = rd.msg || '导入成功！';
                        this.$msg.msgs(rd.msg);
                    }else{
                        this.$msg.msge(rd.msg);
                        this.msg=rd.msg;
                    }
                }).catch(error=>{
                    return Promise.reject(error);
                })
                return false;
            },
            callback(){
                this.$emit("callback",this.resultdata)
                this.$emit("update:visible",false)
            },
            downTemp(){
                this.$emit('downTemp');
            }
        },
    }
</script>
